import { useAppConfig } from "~/app/config/useAppConfig";
import { AddToCartService } from "~/features/addToCart/AddToCartService";
import { ActionIconButton } from "~/common/components/Button/ActionIconButton";
import { usePurchasePlace, usePurchaseType } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import {
  useProductTabularViewModalClose,
  useProductTabularViewModalOpen,
} from "./ProductTabularViewModalContext";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "~/app/store";
// ATC btn
export const AddToCartAction = ({ productCode }: { productCode: string }) => {
  const dispatch = useDispatch<AppDispatch>();
  const purchase_place = usePurchasePlace();
  const purchase_type = usePurchaseType();
  const closeModal = useProductTabularViewModalClose();
  const openPreviousModal = useProductTabularViewModalOpen();
  const webservicesDisabled = useAppConfig()?.configuration.disableAllWS ?? false;

  const openAddToCart = () => {
    AddToCartService.openAddToCartWizard(
      {
        productCode: productCode,
        restrictionQuery: "",
        onCancelCallback: openPreviousModal,
      },
      {
        page: purchase_place,
        recommendationType: purchase_type,
        recommendationPlace: purchase_place,
      },
      dispatch,
    );
    if (closeModal) {
      closeModal();
    }
  };

  return (
    <ActionIconButton
      data-test-id={"tabular-view-action-button-add-to-cart"}
      icon={<ShoppingCartIcon />}
      disabled={webservicesDisabled}
      inverted={true}
      onIconClick={openAddToCart}
      data-ta-spec={"housing_assistant_product_cart"}
    />
  );
};
